import { render } from "./courier.vue?vue&type=template&id=0c68f9f9"
import script from "./courier.vue?vue&type=script&lang=js"
export * from "./courier.vue?vue&type=script&lang=js"

import "./courier.vue?vue&type=style&index=0&id=0c68f9f9&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__